<template>
	<div style="background-color:#fffcf7;" class="container">
		<headMenu />
		<div
			class="w-100 overflow-hidden"
			:class="(windowWidth<=1000)? 'h-center': ''"
		>
			<div class="col-lg-9 col-md-9 col-sm-12 col-xs-12 float-left p-3">
				<part1 @setPage = "setPage"	/>
			</div>
			<div class="col-lg-3 col-md-3 float-left"  v-if="windowWidth>1000">
				<part2 select="17" />
			</div>
		</div>
		<footerPage />
	</div>
</template>

	<script>
		import headMenu from  "../../menu/headMenu.vue";
		import part1 from  "./part1.vue";
		import part2 from  "../../USER/reserved_user_list/part2.vue";
		import footerPage from  "../../USER/public/home/home_part9.vue";
		export default {
			name: 'tick_create',
			data(){
				return {
					
				}
			},
			components: {
				headMenu,
				part1,
				part2,
				footerPage,
			},
			props: [],
			computed :{
			},
			mounted(){
				
			},
			methods:{
				
			}
		}
	</script>
<style>

</style>
